const phoneInput = document.getElementById("phone");
const warning = document.getElementById("phone-warning");
const form = document.querySelector("form");

function isPhoneValid() {
    const pattern = /^\+7\s?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}$/;
    return pattern.test(phoneInput.value.trim());
}

if (form && phoneInput) {
    form.addEventListener("submit", (e) => {
        if (!isPhoneValid()) {
        e.preventDefault(); // останавливаем отправку
        phoneInput.classList.add("invalid");
        warning.style.display = "block";
        phoneInput.focus();
        } else {
        phoneInput.classList.remove("invalid");
        warning.style.display = "none";
        }
    });

    // опционально — маска
    phoneInput.addEventListener("input", (e) => {
        let val = e.target.value.replace(/\D/g, "");
        if (val.startsWith("8")) {
        val = "7" + val.slice(1);
        }
        if (!val.startsWith("7")) {
        val = "7" + val;
        }
        let res = "+7";
        if (val.length > 1) res += " (" + val.slice(1, 4);
        if (val.length >= 4) res += ") " + val.slice(4, 7);
        if (val.length >= 7) res += "-" + val.slice(7, 9);
        if (val.length >= 9) res += "-" + val.slice(9, 11);
        e.target.value = res;
    });
}

document.querySelector("form").addEventListener("keydown", function(e) {
  if (e.key === "Enter") {
    e.preventDefault();
  }
});